import { gql } from '@apollo/client';


export const PERSON_AUTO_SUGGEST = gql`
  query personAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    personAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;